/* hs-eslint ignored failing-rules */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { stringify } from 'hub-http/helpers/params';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import LoginLoading from 'LoginUI/components/LoginLoading';
import BypassLoginDao from 'LoginUI/data/BypassLoginDao';
import GoogleLoginDao from 'LoginUI/data/GoogleLoginDao';
import { checkCookiesAndCsrf, extractRedirectQueryParams } from 'LoginUI/lib/LoginUtils';
import googleLoginNonce from 'LoginUI/lib/googleLoginNonce';
import LoginFailureHandlerFactory from 'LoginUI/lib/LoginFailureHandlerFactory';
import SsoRequiredAuthStatuses from 'LoginUI/constants/SsoRequiredAuthStatuses';
import TwoFactorAuthStatuses from 'LoginUI/constants/TwoFactorAuthStatuses';
import ConfirmToLoginStatuses from 'LoginUI/constants/ConfirmToLoginAuthStatuses';
import { setTwoFactorMethod as setTwoFactorMethodAction, setCredentials } from 'LoginUI/actions';
import { parse as parseQuery } from 'hub-http/helpers/params';
import LoginDao from 'LoginUI/data/LoginDao';
import { getIsInvalidTokenAlertVisible } from 'LoginUI/selectors/TwoFactorAuth';
import { trackLoginPageView } from 'LoginUI/lib/tracker';
import LoginLanding from './LoginLanding';
import { jsx as _jsx } from "react/jsx-runtime";
const STATE = {
  LOGIN: 0,
  BYPASSING_LOGIN: 1
};
const loginDao = new LoginDao();
const appCookieLogin = new HubSpotOnlyAppCookieLogin({
  loginRequest: loginDao.uiLogin.bind(loginDao),
  passThroughFallback: true
});
const bypassLoginDao = new BypassLoginDao();
const googleLoginDao = new GoogleLoginDao();
class LoginLandingContainer extends Component {
  constructor(props) {
    super(props);
    const {
      search
    } = this.props.location;
    const query = parseQuery(search.substr(1));
    const redirectQueryParams = extractRedirectQueryParams(query);
    const {
      autoRedirectGoogle,
      loginPortalId
    } = redirectQueryParams;
    const {
      allowFbSignup,
      bypass,
      ignoreSsoRequired,
      page_id,
      signupParams,
      isOutlook,
      hideSignupLink
    } = query;
    let loginRedirectUrl = redirectQueryParams.loginRedirectUrl;
    if (allowFbSignup && page_id) {
      loginRedirectUrl = `${loginRedirectUrl}&page_id=${page_id}`;
    }
    const skipBypass = bypass === 'false';
    const renderState = autoRedirectGoogle || loginPortalId && !skipBypass ? STATE.BYPASSING_LOGIN : STATE.LOGIN;
    this.state = {
      autoRedirectGoogle,
      ignoreSsoRequired: ignoreSsoRequired === 'true' || false,
      renderState,
      loginPortalId,
      loginRedirectUrl,
      signupParams,
      skipBypass,
      isOutlook,
      hideSignupLink: hideSignupLink === 'true',
      googleLoginRedirectUrl: undefined,
      // todo: assign or delete
      allowFbSignup: allowFbSignup === 'true',
      pageId: page_id
    };
    this.renderLogin = this.renderLogin.bind(this);
    this.loginSubmit = this.loginSubmit.bind(this);
    this.twoFactorOrRedirectOnSuccess = this.twoFactorOrRedirectOnSuccess.bind(this);
    this.confirmToLoginOrGenericError = this.confirmToLoginOrGenericError.bind(this);
    this.googleLoginClick = this.googleLoginClick.bind(this);
    this.ssoLoginClick = this.ssoLoginClick.bind(this);
    this.__renderStatesCached = this.renderStates();
  }
  componentDidMount() {
    const {
      autoRedirectGoogle,
      loginPortalId,
      loginRedirectUrl,
      skipBypass
    } = this.state;
    const loginRenderState = () => {
      this.setState({
        renderState: STATE.LOGIN
      });
    };
    if (autoRedirectGoogle) {
      this.googleLoginClick(loginRenderState);
      return;
    }
    appCookieLogin.loginPrep();
    if (loginPortalId && !skipBypass) {
      const transitionToSsoRequired = () => {
        const nextPath = `/sso?${stringify({
          loginPortalId,
          loginRedirectUrl,
          required: true
        })}`;
        this.props.history.push(nextPath);
      };
      const isRedirectingToJita = redirectUrl => {
        return redirectUrl.indexOf('login/jita') !== -1;
      };
      const checkCookiesAndCsrfAndRedirect = (loginPortalIdForCookies, redirectUrl) => {
        if (isRedirectingToJita(redirectUrl)) {
          window.location.href = redirectUrl; // Safe usage of window.location assignment. This comes back from login service, which checks safety.
          return Promise.resolve();
        }
        return checkCookiesAndCsrf(loginPortalIdForCookies).then(() => {
          window.location.href = redirectUrl; // Safe usage of window.location assignment. This comes back from login service, which checks safety.
        }).catch(() => {
          console.log('Failed checking for csrf cookies, clearing redirectUrl query params');
          loginRenderState();
          const nextPath = `?${stringify({
            loginPortalId
          })}`;
          this.props.history.push(nextPath);
        });
      };
      const ssoRequiredOrBypass = response => {
        if (response.status && response.status === SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED) {
          return transitionToSsoRequired();
        }
        return checkCookiesAndCsrfAndRedirect(loginPortalId, response.redirectUrl);
      };
      /* eslint-disable-next-line promise/catch-or-return */
      bypassLoginDao.bypass({
        loginPortalId,
        loginRedirectUrl
      }).then(ssoRequiredOrBypass, loginRenderState);
    }
    trackLoginPageView();
  }
  twoFactorOrRedirectOnSuccess(responses) {
    const {
      setTwoFactorMethod
    } = this.props;
    const {
      googleLoginRedirectUrl,
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const response = responses[0];
    if (response.status === TwoFactorAuthStatuses.TWO_FACTOR_REQUIRED) {
      const {
        token,
        backupCodesEnabled,
        allowedMethods
      } = response;
      setTwoFactorMethod(token, backupCodesEnabled, allowedMethods);
      const nextPath = `/two-factor?${stringify({
        googleLoginRedirectUrl,
        loginPortalId,
        loginRedirectUrl
      })}`;
      this.props.history.push(nextPath);
    } else if (response.status === SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED) {
      const {
        hubId,
        requiredBy
      } = response;
      const nextPath = `/sso?${stringify({
        loginPortalId: hubId,
        required: true,
        requiredBy,
        loginRedirectUrl
      })}`;
      this.props.history.push(nextPath);
    } else if (response.status === ConfirmToLoginStatuses.SUSPICIOUS_USER_MUST_CONFIRM) {
      const {
        token,
        email,
        rememberLogin
      } = response;
      setTwoFactorMethod(token, false, []);
      this.props.setCredentials({
        token,
        email,
        rememberLogin
      });
      const nextPath = `/confirm-to-login?${stringify({
        loginRedirectUrl,
        loginPortalId
      })}`;
      this.props.history.push(nextPath);
    } else if (response.status === ConfirmToLoginStatuses.NEEDS_LOGIN_LINK) {
      const nextPath = '/confirm-to-login/login-link';
      this.props.history.push(nextPath);
    } else {
      appCookieLogin.redirectOnLoginSuccess(responses);
    }
  }
  confirmToLoginOrGenericError(response, triggerReset) {
    const {
      loginRedirectUrl,
      loginPortalId
    } = this.state;
    if (response.responseJSON && response.responseJSON.status === ConfirmToLoginStatuses.SUSPICIOUS_USER_MUST_CONFIRM) {
      const nextPath = `/confirm-to-login?${stringify({
        loginRedirectUrl,
        loginPortalId
      })}`;
      this.props.history.push(nextPath);
      return Promise.resolve();
    } else if (response.responseJSON && response.responseJSON.status === ConfirmToLoginStatuses.NEEDS_LOGIN_LINK) {
      const nextPath = '/confirm-to-login/login-link';
      this.props.history.push(nextPath);
      return Promise.resolve();
    } else {
      return LoginFailureHandlerFactory.create(triggerReset, this.props.history.push)(response);
    }
  }
  loginSubmit(credentials, triggerReset) {
    const {
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const credentialParams = Object.assign({}, credentials, {
      loginPortalId,
      loginRedirectUrl
    });
    this.props.setCredentials(credentialParams);
    appCookieLogin.login(credentialParams).then(this.twoFactorOrRedirectOnSuccess).catch(response => this.confirmToLoginOrGenericError(response, triggerReset));
  }
  googleLoginClick(triggerReset) {
    const {
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const credentials = {
      loginPortalId,
      loginRedirectUrl
    };
    googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndRedirect).catch(LoginFailureHandlerFactory.createRavenReporter('Google initialization failed', triggerReset, this.props.history.push));
  }
  ssoLoginClick(email) {
    const {
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const params = {
      loginPortalId,
      loginRedirectUrl
    };
    if (email && email !== '') {
      params.email = email;
    }
    const nextPath = `/sso?${stringify(params)}`;
    this.props.history.push(nextPath);
  }
  renderStates() {
    return {
      [STATE.LOGIN]: this.renderLogin,
      [STATE.BYPASSING_LOGIN]: this.renderBypassingLogin
    };
  }
  renderLogin() {
    const {
      isInvalidTokenAlertVisible
    } = this.props;
    const {
      loginRedirectUrl,
      signupParams,
      allowFbSignup,
      hideSignupLink,
      googleLoginRedirectUrl,
      pageId
    } = this.state;
    return /*#__PURE__*/_jsx(LoginLanding, {
      signupParams: signupParams,
      hideSignupLink: hideSignupLink,
      allowFbSignup: allowFbSignup,
      loginRedirectUrl: loginRedirectUrl,
      isInvalidTokenAlertVisible: isInvalidTokenAlertVisible,
      loginSubmit: this.loginSubmit,
      googleLoginClick: this.googleLoginClick,
      googleLoginRedirectUrl: googleLoginRedirectUrl,
      ssoLoginClick: this.ssoLoginClick,
      pageId: pageId
    });
  }
  renderBypassingLogin() {
    return /*#__PURE__*/_jsx(LoginLoading, {});
  }
  render() {
    const {
      renderState
    } = this.state;
    const renderFunction = this.__renderStatesCached[renderState];
    if (renderFunction) {
      return renderFunction();
    } else {
      console.error(`Unknown landing state ${renderState}. Cannot render.`);
      return null;
    }
  }
}
LoginLandingContainer.propTypes = {
  location: PropTypes.object.isRequired,
  isInvalidTokenAlertVisible: PropTypes.bool.isRequired,
  setTwoFactorMethod: PropTypes.func.isRequired,
  setCredentials: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};
const reduxConnect = connect(state => ({
  isInvalidTokenAlertVisible: Boolean(getIsInvalidTokenAlertVisible(state))
}), {
  setCredentials,
  setTwoFactorMethod: setTwoFactorMethodAction
});
export default reduxConnect(LoginLandingContainer);